import React, { useState } from 'react';
import styled from 'styled-components';
import { BorderLessButton } from '../forms/Button';
import useMetronome from '../utility/useMetronome';
import HamQuest from '../api/HamQuestGiver';
import { QuestRoute } from '../api/QuestRoutes';
import Row from '../layout/Row';
import Col from '../layout/Col';
import { SCREEN_WIDTH } from '../stateProvider/StateProvider';
import { generateId, shortHandDate, shortHandDateTimeUTC } from '../utility/functions';
import Modal from '../Modal';
import Icon from '../forms/Icon';
import PageBreak from '../layout/PageBreak';
import LinkTo from '../forms/LinkTo';
import Table from '../table/Table';
import ModalFactory from '../Modal';

const SiteStatus = ({ ...props }) => {
    const [data, setData] = useState([]);
    const [fetchData, setFetchData] = useState(5);

    useMetronome(() => {
        if (fetchData > 0) {
            setFetchData(fetchData - 1)
            HamQuest.get(QuestRoute.dashboard.status)
                .then(res => {
                    res.forEach(loc => {
                        const lastReporting = loc.kiosks.map(e => new Date(e.lastStatusReceivedUtc));
                        loc.lastReporting = SCREEN_WIDTH ? shortHandDate(lastReporting.sort((a, b) => b - a)[0]) : shortHandDateTimeUTC(lastReporting.sort((a, b) => b - a)[0])

                        const errorIndex = {
                            'None': 0,
                            'No Status': 1,
                            'Unknown': 2,
                            'Soft': 3,
                            'Hard': 4
                        }

                        const errorLevel = loc.kiosks.map(e => e.errorLevel);
                        loc.errorLevel = errorLevel.sort((a, b) => errorIndex[b] - errorIndex[a])[0]
                    })
                    setData(res)
                })
                .catch(ex => console.error(ex))
        }
    }, 60000)


    const ErrorLevel = ({ error }) => {
        const errorIndex = {
            'None': 'check',
            'No Status': 'questionMark',
            'Unknown': 'questionMark',
            'Soft': 'exclamationTriangle',
            'Hard': 'skull'
        }
        const colorIndex = {
            'None': '#1fab40',
            'No Status': '#ff5700',
            'Unknown': '#ff5700',
            'Soft': '#ffa200',
            'Hard': '#FF0000'
        }

        return (
            <Row>
                <Icon icon={errorIndex[error]} style={{ color: colorIndex[error] }} />
                {error}
            </Row>
        )
    }


    const showModal = (loc) => {
        const address = [(loc.address1 + ' ' + (loc.address2 ?? '')).trim(), loc.city.trim(), loc.stateProvince.split('-')[1].trim(), loc.zipPostalCode].join(', ');
        ModalFactory.show({
            title: loc.name,
            body: (
                <Col>
                    <span><b>Address</b>: {address}</span>
                    <PageBreak padding={0.5}>
                        {loc.kiosks.map(e => (
                            <Row justify='space-between'>
                                <Col>
                                    <span><b>Kiosk</b>: {e.friendlyName}</span>
                                    <span><b>Model</b>: {e.model}</span>
                                    <span><b>Status</b>: {e.statusDescr}</span>
                                </Col>
                                <ErrorLevel error={e.errorLevel} />
                            </Row>
                        ))}
                    </PageBreak>
                </Col>
            )
        })
    }

    return (
        <Table
            config={{
                disableHeaderSearch: true,
                disableTableControls: true,
                disableMobileView: true,
                data: data,
                headers: [
                    {
                        label: 'Location',
                        propKey: 'name',
                    }, {
                        label: 'Last Reported',
                        propKey: 'lastReporting',
                    }, {
                        label: 'Error Level',
                        propKey: 'errorLevel',
                    }
                ],
                renderFormat: (e) => (
                    <tr key={generateId()}>
                        <td>
                            <LinkTo to={'/locations#' + e.name.replace(/ /g, '')}>{e.name}</LinkTo>
                        </td>
                        <td>{e.lastReporting}</td>
                        <td><BorderLessButton onClick={() => showModal(e)}><ErrorLevel error={e.errorLevel} /></BorderLessButton></td>
                    </tr>
                )
            }}
        />
    );
}

export default SiteStatus;